import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SidebarActions {
  hideSidebar: () => void;
  showSidebar: () => void;
  toggleSidebar: () => void;
}
interface SidebarStore {
  isSidebarOpen: boolean;
  actions: SidebarActions;
}

const useSidebarStore = create<SidebarStore>()(
  devtools(set => ({
    isSidebarOpen: false,
    actions: {
      hideSidebar: () => set({ isSidebarOpen: false }),
      showSidebar: () => set({ isSidebarOpen: true }),
      toggleSidebar: () => set(state => ({ isSidebarOpen: !state.isSidebarOpen }))
    }
  }))
);

export const useIsSidebarOpen = () => useSidebarStore(state => state.isSidebarOpen);
export const useSidebarActions = () => useSidebarStore(state => state.actions);
